import React from "react";

export const Calendar = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5V6.2"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2002 5V6.2"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.60039 11.6001H7.40039V12.2001H8.60039V11.6001Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2 11.6001H11V12.2001H12.2V11.6001Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.60039 14.6001H7.40039V15.2001H8.60039V14.6001Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.2 14.6001H11V15.2001H12.2V14.6001Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.7996 11.6001H14.5996V12.2001H15.7996V11.6001Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.60039 11.6001H7.40039V12.2001H8.60039V11.6001Z"
      fill="#0D0C1C"
    />
    <path d="M12.2 11.6001H11V12.2001H12.2V11.6001Z" fill="#0D0C1C" />
    <path
      d="M8.60039 14.6001H7.40039V15.2001H8.60039V14.6001Z"
      fill="#0D0C1C"
    />
    <path d="M12.2 14.6001H11V15.2001H12.2V14.6001Z" fill="#0D0C1C" />
    <path
      d="M15.7996 11.6001H14.5996V12.2001H15.7996V11.6001Z"
      fill="#0D0C1C"
    />
    <path
      d="M5 9.2002H18.2"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 6.7998H6.2C5.53726 6.7998 5 7.33706 5 7.9998V16.3998C5 17.0625 5.53726 17.5998 6.2 17.5998H17C17.6627 17.5998 18.2 17.0625 18.2 16.3998V7.9998C18.2 7.33706 17.6627 6.7998 17 6.7998Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
